import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import partial from 'lodash/partial';
import range from 'lodash/range';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import 'styles/page-control.scss';
class PageControl extends Component {
    render() {
        const modifiers = {
            [`is-${this.props.appearance}`]: this.props.appearance,
        };
        return (_jsx("div", { className: classnames(this.props.className, 'page-control', modifiers), children: this.props.pages > 8 ? this._renderCounter() : range(this.props.pages).map(this._renderPage.bind(this)) }));
    }
    _renderPage(index) {
        if (this.props.pages <= 1) {
            return null;
        }
        const modifiers = {
            'is-selected': index === this.props.page,
        };
        return (_jsx("div", { className: classnames('page-control__page', modifiers), onClick: partial(this.props.onPageClick, index), children: _jsx("span", {}) }, index));
    }
    _renderCounter() {
        return (_jsxs("div", { className: classnames('page-control__counter'), children: [_jsx("strong", { children: this.props.page + 1 }), " / ", this.props.pages] }));
    }
}
PageControl.propTypes = {
    page: PropTypes.number.isRequired,
    pages: PropTypes.number.isRequired,
    onPageClick: PropTypes.func,
    appearance: PropTypes.oneOf(['black', 'white']),
};
PageControl.defaultProps = {
    page: 0,
    pages: 0,
    onPageClick: () => { },
};
export default PageControl;
